import React from "react";
import "../style.css"; // Import custom CSS file
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from "react-icons/fa";

const GetInTouch = () => {
  return (
    <div className="get-in-touch-container">
      {/* Top Section */}
      <div className="get-in-touch-content">
        <div className="text-left">
          <p className="get-in-touch-intro">Let's</p>
          <h1 className="get-in-touch-title">
            Get in <span className="get-in-touch-highlight">touch</span>
          </h1>
          <p className="get-in-touch-email">customersupport@xebrand.in</p>
        </div>
        <div className="get-in-touch-icons">
          <a href="https://www.facebook.com/xebrandd" target="_blank" rel="noopener noreferrer">
            <FaFacebookF className="icon" />
          </a>
          <a href="https://x.com/Itsjasminder" target="_blank" rel="noopener noreferrer">
            <FaTwitter className="icon" />
          </a>
          <a href="https://www.linkedin.com/in/jasminder-singh-30a298214/" target="_blank" rel="noopener noreferrer">
            <FaLinkedinIn className="icon" />
          </a>
          <a href="https://www.instagram.com/itsjasmindereditz/" target="_blank" rel="noopener noreferrer">
            <FaInstagram className="icon" />
          </a>
        </div>
      </div>

      {/* Footer Section */}
      <div className="get-in-touch-footer">
        <div className="footer-brand">Xebrand</div>
      </div>
    </div>
  );
};

export default GetInTouch;
